<template>
	<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fill-rule="evenodd" clip-rule="evenodd" d="M1.6665 9.99996C1.6665 5.39996 5.39984 1.66663 9.99984 1.66663C14.5998 1.66663 18.3332 5.39996 18.3332 9.99996C18.3332 14.6 14.5998 18.3333 9.99984 18.3333C5.39984 18.3333 1.6665 14.6 1.6665 9.99996ZM9.99984 15C9.5396 15 9.1665 14.6269 9.1665 14.1666V9.16663C9.1665 8.70639 9.5396 8.33329 9.99984 8.33329C10.4601 8.33329 10.8332 8.70639 10.8332 9.16663V14.1666C10.8332 14.6269 10.4601 15 9.99984 15ZM9.99984 16.6666C6.32484 16.6666 3.33317 13.675 3.33317 9.99996C3.33317 6.32496 6.32484 3.33329 9.99984 3.33329C13.6748 3.33329 16.6665 6.32496 16.6665 9.99996C16.6665 13.675 13.6748 16.6666 9.99984 16.6666ZM9.99984 7.49996C9.5396 7.49996 9.1665 7.12686 9.1665 6.66663C9.1665 6.20639 9.5396 5.83329 9.99984 5.83329C10.4601 5.83329 10.8332 6.20639 10.8332 6.66663C10.8332 7.12686 10.4601 7.49996 9.99984 7.49996Z" :fill="fill_color" :fill-opacity="opacity"/>
	</svg>
</template>

<script>
import base_icon from '@/components/icons/base_icon';

export default {
	extends: base_icon
}
</script>
